module.exports = __webpack_public_path__ + "static/media/Back_Chevron_Dark.18da58f8.svg";